import {ADMIN_DASHBOARD_LINK, USER_DASHBOARD_LINK} from "@/config/link";

export const navigateToLogin = (forceUser = false) => {
    if(window.location.pathname.startsWith("/app")){
       window.location.href = "/login";
    }else{
       window.location.href = "/backend/login"
    }
}

export const navigateToRegister= () => {
    window.location.href = "/register"
}

export const navigateToDashboard = (isUser = false) => {
    window.location.href = isUser ? USER_DASHBOARD_LINK : ADMIN_DASHBOARD_LINK;
}

export const navigateToBackendLogin = () => {
    window.location.href = "/backend/login"
}
